import { setGetEmployeesParams, setSearchPopoverOpen }
  from "../employeeSlice";
import { useAppDispatch } from "hooks/hooks";
import {
  Control,
  Controller,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetFocus,
  UseFormSetValue
} from "react-hook-form";
import EmployeeRoleSelect from "./EmployeeRoleSelect";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { GenderType } from "Dashboard/scenes/HumanResources/domain/GenderType";
import { IGetAllEmployeesRequestParams } from "Dashboard/scenes/HumanResources/domain/IGetAllEmployeesRequestParams";
import { useEffect, useState } from "react";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesHr from "../../../popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IGetAllEmployeesRequestParams>;
  register: UseFormRegister<IGetAllEmployeesRequestParams>;
  control: Control<IGetAllEmployeesRequestParams, any>;
  setFocus: UseFormSetFocus<IGetAllEmployeesRequestParams>;
  getValues: UseFormGetValues<IGetAllEmployeesRequestParams>;
  setValue: UseFormSetValue<IGetAllEmployeesRequestParams>;
};

const SearchEmployeePopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    register,
    control,
    setFocus,
    getValues,
    setValue
  } = props;

  const [employedUntilDateRange, setEmployedUntilDateRange] = useState<[Date | null, Date | null]>(
    [getValues("employedUntilFrom") ? new Date(getValues("employedUntilFrom")!) : null,
    getValues("employedUntilTo") ? new Date(getValues("employedUntilTo")!) : null]);

  const [employedAtDateRange, setEmployedAtDateRange] = useState<[Date | null, Date | null]>(
    [getValues("employedAtFrom") ? new Date(getValues("employedAtFrom")!) : null,
    getValues("employedAtTo") ? new Date(getValues("employedAtTo")!) : null]);

  const onSubmit = async (data: IGetAllEmployeesRequestParams) => {
    try {
      close();
      dispatch(setGetEmployeesParams(data));
    } catch (err) {
      console.error(err);
    }
  };

  const close = () => {
    dispatch(setSearchPopoverOpen({ isOpen: false }));
  };

  useEffect(() => {
    setFocus("employeeName");
  }, [setFocus]);

  return (
    <form className={`${classesHr.hrSearchPopover} ${classes.basicPopover}`}
      onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>ime i prezime</label>
          <input type="text" className={classes.itemBorder}
            {...register("employeeName")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>pol</label>
          <select className={classes.itemBorder}
            {...register("gender")}>
            <option value={""}></option>
            <option value={GenderType.MALE}>Muško</option>
            <option value={GenderType.FEMALE}>Žensko</option>
          </select>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>radno mesto</label>
          <Controller
            name="employeeRoleId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <EmployeeRoleSelect
                value={getValues("employeeRoleId")}
                onChange={onChange}
                styles={styles.customStyleClassic}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>prijavljen do</label>
          <div className="datepickerWrapper">
            <DatePicker
              selectsRange={true}
              startDate={employedUntilDateRange[0]}
              endDate={employedUntilDateRange[1]}
              showMonthDropdown
              showYearDropdown
              onChange={(date: any) => {
                setEmployedUntilDateRange([date[0], date[1]]);
                setValue("employedUntilFrom", date[0] && FormatDateIso(date[0]));
                setValue("employedUntilTo", date[1] && FormatDateIso(date[1]));
              }}
              isClearable={true}
              className={`${classes.dateItem} ${classes.itemBorder}`}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>počeo sa radom</label>
          <div className="datepickerWrapper">
            <DatePicker
              selectsRange={true}
              startDate={employedAtDateRange[0]}
              endDate={employedAtDateRange[1]}
              showMonthDropdown
              showYearDropdown
              onChange={(date: any) => {
                setEmployedAtDateRange([date[0], date[1]]);
                setValue("employedAtFrom", date[0] && FormatDateIso(date[0]));
                setValue("employedAtTo", date[1] && FormatDateIso(date[1]));
              }}
              isClearable={true}
              className={`${classes.dateItem} ${classes.itemBorder}`}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchEmployeePopover;
